import { render, staticRenderFns } from "./editBus.vue?vue&type=template&id=5edfedde"
import script from "./editBus.vue?vue&type=script&lang=js"
export * from "./editBus.vue?vue&type=script&lang=js"
import style0 from "./editBus.vue?vue&type=style&index=0&id=5edfedde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports